import React from 'react';
import CreateRocket from '../../redux/features/rockets/CreateRocket';

const Rockets = () => (
  <div>
    <CreateRocket />
  </div>
);
export default Rockets;
